module.exports = __webpack_public_path__ + "static/media/yesterdayImageMobile.e274a354.png";